<div class="userSettingPages">
  <div class="headerDecs">
    <h2>{{ this.title }}</h2>
    <span>{{ 'desc_deposit_apcopay' | t }}</span>
  </div>

  <ng-container *ngIf="this.firststep">
    <div style="width: 100%; display: flex; justify-content: center; margin-top: 5px; margin-bottom: 5px">
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
        <mat-button-toggle (click)="changeAmount(25)" value="25">25€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(50)" value="50">50€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(75)" value="75">75€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(100)" value="100">100€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(100)" value="150">150€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(200)" value="200">200€</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <form [formGroup]="coinbaseDatas" style="width: 100%">
      <mat-form-field style="width: 100%">
        <input matInput placeholder="{{ 'Amount' | t }}" type="number" formControlName="amount" />
        <mat-error *ngIf="!coinbaseDatas.valid">
          Min : <strong>{{ this.MinValue }}</strong> - Max : <strong>{{ this.MaxValue }}</strong>
        </mat-error>
      </mat-form-field>
    </form>

    <button mat-raised-button class="form-submit-button" (click)="submitCoinbaseData()" [disabled]="!coinbaseDatas.valid">{{ 'Pay' | t }}</button>

    <br /><br />
    <mat-divider style="margin: 30px 100px"></mat-divider>
    <ng-container *ngIf="insicstatus != '2'">
      <div>
        <div style="display: flex; font-size: 12px; padding: 5px">
          <div style="font-weight: bold">{{ 'First_Name' | t }}&nbsp;{{ 'Last_Name' | t }}:&nbsp;</div>
          <div>{{ this.userProfileList?.CustomerName }}&nbsp;{{ this.userProfileList?.CustomerSurname }}</div>
        </div>
        <div style="display: flex; font-size: 12px; padding: 5px">
          <div style="font-weight: bold">{{ 'Email' | t }}&nbsp;:&nbsp;</div>
          <div>{{ this.userProfileList?.Email }}</div>
        </div>
        <div style="display: flex; font-size: 12px; padding: 5px">
          <div style="font-weight: bold">{{ 'bday' | t }}&nbsp;:&nbsp;</div>
          <div>{{ this.userProfileList?.Birthday }}</div>
        </div>
        <div style="display: flex; font-size: 12px; padding: 5px">
          <div style="font-weight: bold">{{ 'address' | t }}&nbsp;:&nbsp;</div>
          <div>{{ this.userProfileList?.OddsFormatId }},{{ this.userProfileList?.Address }},{{ this.userProfileList?.ZipCode }},{{ this.userProfileList?.City }}</div>
        </div>
        <div style="display: flex; font-size: 12px; padding: 5px">
          <div style="font-weight: bold">{{ 'Phone_Number' | t }}&nbsp;:&nbsp;</div>
          <div>{{ this.userProfileList?.PhoneNumber }}</div>
        </div>
      </div>
      <mat-divider style="margin: 30px 100px"></mat-divider>
      <div class="home-register">
        <div class="text">Für Limiterhöhung müssen sie sich komplett Verifizieren</div>
        <div class="button" [routerLink]="['/userprofile']" style="padding: 12px; cursor: pointer">{{ 'MyAccount' | t }}</div>
      </div>
      <mat-divider style="margin: 30px 100px"></mat-divider>
    </ng-container>
    <div class="home-register" *ngIf="this.typeid == 1">
      <a href="https://a.api.muchbetter.com/merchant/user?trackingCode=SUIxMDQ4Nzc5"
        ><img style="width: 50px" class="icon" [src]="'/images/deposit/apcomuch.png' | getAssetsPath" alt="MuchBetter"
      /></a>
      <div class="text">{{ 'registermuchbetter' | t }}</div>
    </div>
  </ng-container>
  <ng-container *ngIf="!this.firststep">
    <iframe [src]="iframesrc" style="width: 100%; height: 1100px" (load)="paymentpageLoaded()"></iframe>
  </ng-container>
</div>
